module.exports = __webpack_public_path__ + "static/screen-classic-mac-laptop-82d1da2af261a0a120bb5d02d1b4d167.png";